import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgEntityServiceLoader } from '@datorama/akita-ng-entity-service';
import { Subscription } from 'rxjs';
import { CsProject } from '../state/cs-project.model';
import { csProjectStoreName } from '../state/cs-project.store';
import { CsProjectsService } from '../state/cs-projects.service';

@Component({
  selector: 'app-delete-cs-project-dialog',
  templateUrl: './delete-cs-project-dialog.component.html',
  styleUrls: ['./delete-cs-project-dialog.component.scss']
})
export class DeleteCsProjectDialogComponent implements OnInit, OnDestroy {
  csProject: CsProject;
  private internalError: string;
  private internalIsBusy: boolean;
  private loaderSubscription: Subscription;

  public get error(): string {
      return this.internalError;
  }

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  constructor(private service: CsProjectsService,
              private loader: NgEntityServiceLoader,
              public dialogRef: MatDialogRef<DeleteCsProjectDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any) { }

  ngOnInit(): void {
    this.csProject = this.dialogData.csProject;
    this.loaderSubscription = this.loader.loadersFor(csProjectStoreName).delete$.subscribe(
      isLoading => this.internalIsBusy = isLoading);
  }

  ngOnDestroy(): void {
    this.loaderSubscription.unsubscribe();
  }

  public deleteProject(): void {
    this.internalError = undefined;
    this.service.delete<CsProject>(this.csProject.id).subscribe(
      deletedProject => this.dialogRef.close(deletedProject),
      error => { this.internalError = error.message; });
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
